export default {
  SEARCH_BOX_PLACEHOLDER: 'Search over 1M+ parts',
  SELECT_YOUR_VEHICLE_BLOCK: 'Shop by vehicle',
  PRODUCT_REPEATER_CLASS:
    'grid mb-8 md:mb-12 grid-cols-1 xs:grid-cols-2 small-cards-mobile s:grid-cols-3 md:grid-cols-3 gap-x-theme gap-y-8 main-products-grid',
  RELATED_PRODUCT_LIST_CLASS:
    'slider slider__grid grid grid-flow-col auto-cols-1 small-cards-mobile xs:auto-cols-2 s:auto-cols-3 md:auto-cols-3 lg:auto-cols-4 xl:auto-cols-5 small-cards-desktop gap-x-theme gap-y-8',
};
